import { getProducts, getRedeemableSortingItems } from "@/utils/apis/order-service";
import { ProductType } from "@/utils/enums/ProductType";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useProductsStore } from "@/utils/stores/useProductsStore";
import { useUserStore } from "@/utils/stores/useUserStore";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

export const useCheckPurchases = () => {
    const navigate = useNavigate();
    const { auth } = useAuthStore();
    const { userData } = useUserStore();
    const email = userData.email;
    const { updateProductsData } = useProductsStore();

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    const checkPurchases = useCallback(async () => {
        if (!auth.idToken || !auth.userId || !email) {
            setError(true)
            setIsLoading(false)
            return
        }

        try {
            // First, check for redeemable items
            const items = await getRedeemableSortingItems(email, auth.idToken);
            if (items.length > 0) {
                navigate("/sorting");
                return; // Exit early if sorting items found
            }

            // Then, check for products
            const products = await getProducts(auth.userId, auth.idToken);
            if (products && products.length > 0) {
                products.forEach((product) => {
                    if (product.product_type === ProductType.DnaTest) {
                        updateProductsData({ dnaTest: product.data.channel })
                    }
                })
                navigate("/fetch-data"); // Navigate to fetch data if products are found
            } else {
                navigate("/redeem"); // No products found, navigate to redeem page
            }
        } catch (e) {
            console.error("Error fetching products:", e instanceof Error ? e.message : e);
            setError(true);
        } finally {
            setIsLoading(false);
        }
    }, [auth.idToken, auth.userId, email, updateProductsData, navigate]);

    return { checkPurchases, isLoading, error }
}